export const hospitalDataActions = {
  FETCH_HOSPITAL: {
    REQUEST: 'hospital/fetch-hospital-request',
    SUCCESS: 'hospital/fetch-hospital-success',
    FAILURE: 'hospital/fetch-hospital-failure',
    RESET: 'hospital/fetch-hospital-reset' // Optional: to reset the state (e.g., clear form on error or after successful fetch)
  },
  UPDATE_HOSPITAL: {
    REQUEST: 'hospital/update-hospital-request',
    SUCCESS: 'hospital/update-hospital-success',
    FAILURE: 'hospital/update-hospital-failure',
    RESET: 'hospital/update-hospital-reset' // Optional: to reset the state (e.g., clear form on error or after successful update)
  }
};
